import { ChangeDetectionStrategy, ChangeDetectorRef, Component, input, OnInit } from '@angular/core';
import { ThreeColumnTemplateComponent } from '@templates/three-column-template/three-column-template.component';
import { IDetails_Response, INews_Item } from '@shared/constants/models.const';
import { CkViewerComponent } from '@shared/components/ck-viewer/ck-viewer.component';
import { TranslateModule } from '@ngx-translate/core';
import { IWorldParts, JURISDICTIONS, worldParts } from './jurisdiction.model';
import { ContentService } from '../../services/content.service';
import { AddFrPipe } from '@shared/pipes/add-fr.pipe';
import { SideNavigationComponent } from '@shared/components/side-navigation/side-navigation.component';
import { LinksSectionComponent } from '@shared/components/links-section/links-section.component';
import { HelperService } from '../../services/helper.service';
import { DefaultPortletsComponent } from '@shared/components/default-portlets/default-portlets.component';


@Component({
  selector: 'app-jurisdiction-list',
  imports: [
    ThreeColumnTemplateComponent,
    CkViewerComponent,
    TranslateModule,
    AddFrPipe,
    SideNavigationComponent,
    LinksSectionComponent,
    DefaultPortletsComponent,
  ],
  templateUrl: './jurisdiction-list.component.html',
  styleUrl: './jurisdiction-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JurisdictionListComponent implements OnInit {
  pageData = input<IDetails_Response | any>();

  worldParts: IWorldParts[] = [];
  itemsList: Array<INews_Item[]> = [];

  constructor(
    private CONTENT: ContentService,
    private HELPER: HelperService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.getContinentData();
    this.getContinentItems();
  }

  getContinentItems() {
    if (this.pageData().folderId === this.getID()) return;
    this.CONTENT.getContinentItems(this.pageData().folderId)
      .subscribe(data => {
        if (data?.items?.length) {

          const itemsArr = data.items;
          const itemsLength = itemsArr.length;
          const itemsPerColumn = Math.ceil(itemsLength / 3);
          const finalArr = [];

          finalArr.push(itemsArr.slice(0, itemsPerColumn));
          finalArr.push(itemsArr.slice(itemsPerColumn, itemsPerColumn * 2));
          finalArr.push(itemsArr.slice(itemsPerColumn * 2));

          this.itemsList = finalArr;
        }
        this.cd.markForCheck();
      });
  }

  getID(): number | null {
    const menuItem = this.HELPER.menuItems.find(item => item.sourceUrl.includes(JURISDICTIONS));
    return menuItem ? menuItem.folderId : null;
  }

  getContinentData() {
    const folderID = this.getID();
    if (!folderID) return;

    this.CONTENT.getContinentsParts(folderID)
      .subscribe(data => {
        const urlArr = this.HELPER.getUrlArray();
        this.worldParts = worldParts.map(wp => {

          const dataItem = data.find(item => item.sourceUrl.includes(wp.name));
          if (dataItem) {
            wp.sourceUrl = dataItem.sourceUrl;
            wp.title = dataItem.title;
            wp.active = urlArr.includes(wp.name);
          }

          return wp;
        });
        this.cd.markForCheck();
      });
  }

}
